<div class="lua-badge">
  <div *ngIf="number > 0" class="cercle">
    {{ number }}
  </div>
  <ng-content></ng-content>
</div>
